import MessageTask from './center/messageTask';
import MessageTaskDetail from './center/messageTaskDetail';
import NoticeRecord from './noticeRecord/index'
import NoticeRecordDetail from './noticeRecord/detail/index'

export {
  MessageTask,
  MessageTaskDetail,
  NoticeRecord,
  NoticeRecordDetail
}


